import { FeatureFlagKey } from 'featureFlags/types'
import { AbbyAccessPolicy } from 'utils/accessPolicy'

export interface AntMenuItem {
  key: string
  icon?: JSX.Element | undefined
  children?: AntMenuItem[] | undefined
  label: string | JSX.Element
  type?: string | undefined
  disabled?: boolean | undefined
  roles?: AbbyAccessPolicy[] | undefined
  devOnly: boolean
  featureFlag?: { key: FeatureFlagKey; ifDisabled: boolean; ifEnabled: boolean }
  /** Show when any listed flag is enabled (OR). Use when a single `featureFlag` is too narrow. */
  anyFeatureFlags?: FeatureFlagKey[]
}

export enum MenuItemKey {
  HOME = '/',
  TASKS = '/tasks',
  ONBOARDING = '/onboarding',
  ONBOARDING_DOCS = '/onboarding/docs',
  ONBOARDING_LEAD = '/onboarding/lead',
  ONBOARDING_LEADS = '/onboarding/leads',
  PATIENTS = '/patients',
  EMPLOYEES = '/employees',
  CLINICAL = '/clinical',
  CLINICAL_ASSESSMENTS = '/clinical/assessments',
  CLINICAL_PROVIDERS = '/clinical/providers',
  SCHEDULE = '/schedule',
  FLOWS = '/flows',
  PAYROLL = '/payroll',
  REPORTS = '/reports',
  REPORTS_V2 = '/reports',
  BILLING = '/billing',
  ADMIN = '/admin',
  ADMIN_ONBOARDING = '/admin/onboarding',
  ACCESS_MANAGEMENT = '/admin/access-management',
  TRACK_BUILDER = '/admin/track-builder',
  HETS_SURVEYS = '/hets-surveys',
  ADMIN_TOOLS = '/admin/tools'
}
